import { motion, useScroll, useTransform } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import videoSrc from "../../assets/video/vid1.mp4";
import "./videoPlayer.css";
import { useResolution } from "../../utils/resolutionControll";

const VideoPlayer = () => {
  const containerRef = useRef(null);

  const width = useResolution();
  const isMobile = width < 5000;

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"],
  });

  const scale = useTransform(scrollYProgress, [0, 1], [0.5, 4]);

  const [videoSize, setVideoSize] = useState({
    width: "auto",
    height: "auto",
  });

  useEffect(() => {
    return scale.on("change", (latest) => {
      console.log(latest);
      if (latest > 1.5) {
        setVideoSize({
          width: "auto",
          height: "auto",
        });
      } else {
        setVideoSize({
          width: "auto",
          height: "auto",
        });
      }
    });
  }, [scale]);

  return (
    <motion.div
      style={{
        height: "200vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {isMobile ? (
        <motion.div
          style={{
            width: 'auto',
            zIndex: 1,
          }}
          className="video-mask"
        >
          <video
            src={videoSrc}
            autoPlay
            loop
            muted
            playsInline
            className="rounded-xl shadow-lg"
            style={{
              display: "block",
              width: 'auto',
              height: 'auto',
            }}
          />
        </motion.div>
      ) : (
        <motion.div
          style={{
            scale,
            maxWidth: "800px",
            maxHeight: "800px",
            zIndex: 1,
          }}
          className="video-mask"
        >
          <video
            src={videoSrc}
            autoPlay
            loop
            muted
            playsInline
            className="rounded-xl shadow-lg"
            style={{
              display: "block",
              width: videoSize.width,
              height: videoSize.height,
            }}
          />
        </motion.div>
      )}

      <motion.div
        style={{ marginTop: "500px", height: "1px", width: "1px" }}
        ref={containerRef}
      ></motion.div>
    </motion.div>
  );
};

export default VideoPlayer;
